import RauCu from "../images/raucu.jpg"
import KhaiVi from "../images/khaivi.webp"
import Du from "../images/du.webp"
import MonGoi from "../images/mongoi.jpg"
import MonKho from "../images/monkho.jfif"
import TSD from "../images/tsd.jfif"
import Hau from "../images/hau.jpg"
import DS from "../images/ds.jpg"
import Muc from "../images/muc.jpg"
import CaMu from "../images/camu.png"
import BongLau from "../images/bonglau.png"
import De from "../images/de.jpg"
import Bo from "../images/bo.jpg"
import Ga from "../images/ga.jpg"
import Mi from "../images/mi.jpg"
import Lau from "../images/lau.jpg"
import Hsh from "../images/hsh.jpg"
import Doi from "../images/doi.jpg"

export const MenuList = [
  {
    name: "Món Khai Vị",
    image: KhaiVi
  },
  {
    name: "Món Gỏi",
    image: MonGoi
  },
  {
    name: "Rau củ Quả",
    image: RauCu
  },
  {
    name: "Các Loại Khô",
    image: MonKho
  },
  {
    name: "Hàu-Sò Huyết-Ốc",
    image: Hau
  },
  {
    name: "Món Đặc Sản",
    image: DS
  },
  {
    name: "Mực-Tôm-Cua",
    image: Muc
  },
  {
    name: "Cá Mú, Cá lăng, Cá Chình",
    image: CaMu
  },
  {
    name: "Cá Bóp, Cá Bông Lau, Cá Kèo",
    image: BongLau
  },
  {
    name: "Món Heo - Dê",
    image: De
  },
  {
    name: "Món Bò",
    image: Bo
  },
  {
    name: "Món Gà - Vịt",
    image: Ga
  },
  {
    name: "Món Thủy Sản Đồng",
    image: TSD
  },
  {
    name: "Món Cơm - Mì",
    image: Mi
  },
  {
    name: "Món Lẩu",
    image: Lau
  },
  {
    name: "Hải Sản Tại Hồ",
    image: Hsh
  },
  {
    name: "Món Dồi",
    image: Doi
  },
  {
    name: "Đồ Uống",
    image: Du
  }
];
